/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * TranslationService.tsx
 */

import {Listener, Service} from "../service/Service";
import Translation from "../../services/translation/Translation";
import TranslationFR from "../../services/translation/TranslationFR";
import TranslationEN from "../../services/translation/TranslationEN";

const LOCALSTORAGE_LANGUAGE_KEY = "lang_portal";

export interface TranslationListener extends Listener<Translation> {
    translationUpdated(t: Translation): void;
}

export default class TranslationService extends Service<Translation, TranslationListener> {
    private _translation: Translation;
    public id: String = "TranslationService";

    constructor() {
        super();

        this.toggleLanguage = this.toggleLanguage.bind(this);
        this.notifyListeners = this.notifyListeners.bind(this);

        switch (TranslationService._getCurrentLanguage()) {
            case "fr":
                this._translation = new TranslationFR();
                break;
            default:
                this._translation = new TranslationEN();
                break;
        }
    }

    private static _getCurrentLanguage() {
        if (/^fr\b/.test(navigator.language)) {
            return 'fr';
        }
        return 'en';
    }


    /**
     * start
     */
    public start() {
    }

    /**
     * stop
     */
    public stop() {
    }

    /**
     * translation
     * @returns {Translation}
     */
    public get translation(): Translation {
        return this._translation;
    }

    /**
     * toggleLanguage
     */
    public toggleLanguage() {
        if (this._translation.languageKey.toLowerCase() === "fr") {
            this._translation = new TranslationEN();
        } else {
            this._translation = new TranslationFR();
        }

        localStorage.removeItem(LOCALSTORAGE_LANGUAGE_KEY);
        localStorage.setItem(LOCALSTORAGE_LANGUAGE_KEY, this._translation.languageKey);

        this.notifyListeners();
    };

    /**
     * notifyListeners
     */
    public async notifyListeners() {
        this.listeners.forEach(listener => listener.translationUpdated(this._translation))
    };
}
